'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="max-w-md w-full space-y-8 p-8 bg-zinc-900 rounded-lg shadow-lg border border-zinc-800">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-red-500 mb-4">500</h1>
          <h2 className="text-2xl font-semibold text-white mb-4">
            Oops! Something went wrong
          </h2>
          <p className="text-zinc-400 mb-8">
            We apologize for the inconvenience. Please try again later.
          </p>
          <div className="space-y-4">
            <button
              onClick={() => reset()}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Try again
            </button>
            <button
              onClick={() => (window.location.href = '/')}
              className="w-full px-4 py-2 text-sm font-medium text-zinc-200 bg-zinc-800 rounded-md hover:bg-zinc-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zinc-500"
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
